import React from "react";
import Form from "../../common/form";
import ReactModal from "react-modal";
import schema from './mobileLogisticsPlanningAccountSchema';

class MobileLogisticsPlanningAccount extends Form {

    constructor() {
        super();
        this.setDataAndSchema();
    }

    state = {
        ...this.state,
        sortContactPersons: {
            currentPage: 1,
            pageSize: 1000,
            sortColumn: {path: "surname", order: "asc"},
            searchQuery: ""
        }
    }


    baseInformation = schema;

    componentDidMount = async () => {

        const {showModal} = this.props;

        if (!showModal)
            return;

    };

    onChangeContactPersons = contactPersons => {
        // console.log("MobileLogisticsPlanningDataForm.onChangeVehicles(): this.state.data.contactPersons=", this.state.data.contactPersons)
        // console.log("MobileLogisticsPlanningDataForm.onChangeVehicles(): contactPersons=", contactPersons)

        // handleChange = ({currentTarget: input})
        const newData = {...this.state.data};
        newData["company"]["contactPersons"] = [...contactPersons]

        this.setState({data: newData});

    }

    onSortContactPersons = sortColumn => {
        // console.log("MobileLogisticsPlanningDataForm.onSortContactPersons(): newSortColumn=", sortColumn, ", this.state.sortContactPersons.sortColumn", this.state.sortContactPersons.sortColumn)
        const newSortContactPersons = {...this.state.sortContactPersons};
        newSortContactPersons["sortColumn"] = {...sortColumn};
        this.setState({sortContactPersons: newSortContactPersons});
    };


    render = () => {
        const {
            showModal, style, ariaHideApp,
            companyTypeText
        } = this.props;
        const {
            data,
            sortContactPersons
        } = this.state;

        return (
            <React.Fragment>
                <ReactModal
                    isOpen={showModal}
                    contentLabel="MobileLogisticsPlanningAccount"
                    style={style}
                    ariaHideApp={ariaHideApp}
                >
                    <h1>Konto verwalten</h1>

                    {this.renderCard(
                        "Anmeldedaten",
                        [
                            {"name": "username"},
                            {"name": "password"}
                        ]
                    )}
                    {this.renderCard(
                        "Unternehmerdaten",
                        [
                            {"name": "company.name"},
                            {
                                "name": "company.contactPersons",
                                "sort": sortContactPersons,
                                "handleChange": this.onChangeContactPersons,
                                "handleSort": this.onSortContactPersons,
                                "columns": [
                                    {
                                        path: "firstname",
                                        label: "Vorname",
                                    },
                                    {
                                        path: "surname",
                                        label: "Nachname",
                                    },
                                    {
                                        path: "mobileNumber",
                                        label: "Mobilenummer",
                                    },
                                    {
                                        path: "email",
                                        label: "Email",
                                    }
                                ],
                                "addButton": {
                                    text: "Kontaktperson hinzufügen",
                                    // handleAdd: this.onAddContactPerson
                                },
                                "deleteButton": {
                                    text: "löschen"
                                }
                            }
                        ],
                    )}

                    <div className="card">
                        <div className="card-body">
                            <div className="form-group row">
                                <div className="col-md-1">
                                    {this.renderSaveButton({})}
                                </div>
                                <div className="col-md-1">
                                    {this.renderCancelButton({})}
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*</form>*/}
                </ReactModal>
            </React.Fragment>
        );
    }
}

export default MobileLogisticsPlanningAccount;
